import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ComboBox } from "@activecollab/components";
import PropTypes from "prop-types";
import { getFavoriteProjectIds } from "~/store/selectors/selector.favorites";

export const ProjectPickerWithFavorites = ({ projects, excludeProjectId, autoFocus, ...rest }) => {
  const { t } = useTranslation();
  const favoriteProjectIds = useSelector(getFavoriteProjectIds);
  const ref = useRef(null);

  const options = projects
    ? Object.entries(projects)
        .map(([id, name]) => ({ id: Number(id), name }))
        .filter((option) => option.id !== excludeProjectId)
        .reduce((acc, option) => {
          const isInFavorites = favoriteProjectIds.includes(option.id);
          const index = isInFavorites ? 0 : 1;

          if (!acc[index]) {
            acc[index] = {
              id: index + 1,
              name: index === 0 ? t("Favorites") : t("Others"),
              options: [],
            };
          }

          acc[index].options.push(option);
          return acc;
        }, [])
    : [];

  useEffect(() => {
    if (autoFocus && ref.current) {
      const input = ref.current.querySelector(".project-picker input");
      input.focus();
    }
  }, [autoFocus, ref]);

  return (
    <div ref={ref}>
      <ComboBox
        inputWrapperClassName="project-picker"
        options={options}
        {...rest}
        noResultText={t("No Projects")}
      />
    </div>
  );
};

ProjectPickerWithFavorites.propTypes = {
  projects: PropTypes.object,
  excludeProjectId: PropTypes.number,
  autoFocus: PropTypes.bool,
};

ProjectPickerWithFavorites.defaultProps = {
  projects: {},
};
